import { OrderIntentionsFiltersParam } from 'model/types';
import baseApi from './config';

export function fetchMyOrderIntentions(params: OrderIntentionsFiltersParam) {
  return baseApi.get(`/api/order`, {
    params,
  });
}
